import type { RouteRecordRaw } from "vue-router";

export const publicKonekRoutes = [
  {
    path: "enquiry-quote",
    name: "public-enquiry-quote",
    component: () => import("@/pages/konek/enquiry-quote.vue"),
    meta: {
      public: true,
    },
  },
  {
    path: "enquiry-quote/thank-you",
    name: "public-enquiry-quote-thank-you",
    component: () => import("@/pages/konek/enquiry-quote-thank-you.vue"),
    meta: {
      public: true,
    },
  },
] satisfies RouteRecordRaw[];
